<div class="comment">
  <div class="comment_header">
    <div class="avatar">
      <ng-container *ngIf="review.backpacker?.profilePicture">
        <img ngOptimizedImage [ngSrc]="review.backpacker.profilePicture!" [fill]="true" alt="">
      </ng-container>
      <ng-container *ngIf="!review.backpacker?.profilePicture">
        <img ngOptimizedImage ngSrc="https://storage.googleapis.com/hostel-hop-public-storage/images/empty_profile.png" [fill]="true" alt="">
      </ng-container>
    </div>
    <div class="name_and_country">
      <div class="name">
        <ng-container *ngIf="review.backpacker?.username">
          {{review.backpacker.username}}
        </ng-container>
      </div>
      <div class="country">
        <ng-container *ngIf="review.backpacker?.nationality">
          <app-flag-emoji [countryCode]="review.backpacker.nationality!"></app-flag-emoji>&nbsp;{{review.backpacker.nationality!}}
        </ng-container>
      </div>
    </div>
  </div>
  <div class="comment_line_2">
    <div class="rating_outof">
      <div class="rating">
        <svg-icon [src]="'assets/icons/star_rating.svg'"></svg-icon>
        <span class="rating-space">{{review.rating}}/10</span>
      </div>
    </div>
  
    <div class="created-at-date">
      <div class="dot">
      </div>
      {{ getFormattedDate(review.createdAt)}}
    </div>
  </div>
  <div class="comment_badges" *ngIf="review.badges && review.badges.length > 0">
    <button [@fadeIn] class="badge" *ngFor="let badge of top3Badges">
      <svg-icon style="height: 18.2px" [svgStyle]="{'width.px': 18.2, 'height.px': 18.2}" [src]="badge.icon"></svg-icon>
      <span>{{badge.name}}</span>
    </button>
  </div>
  <div class="comment_text">
    {{review.review}}
  </div>
</div>
